// Taiwan cities array with priority for sorting
export const citiesArray = [
  // 北部 Northern Taiwan (priority: 100-90)
  { text: '基隆市Keelung City', value: '基隆市Keelung City', priority: 100 },
  { text: '臺北市Taipei City', value: '臺北市Taipei City', priority: 99 },
  { text: '新北市New Taipei City', value: '新北市New Taipei City', priority: 98 },
  { text: '桃園市Taoyuan City', value: '桃園市Taoyuan City', priority: 97 },
  { text: '新竹市Hsinchu City', value: '新竹市Hsinchu City', priority: 96 },
  { text: '新竹縣Hsinchu County', value: '新竹縣Hsinchu County', priority: 95 },
  // 中部 Central Taiwan (priority: 89-80)
  { text: '苗栗市Miaoli City', value: '苗栗市Miaoli City', priority: 89 },
  { text: '苗栗縣Miaoli County', value: '苗栗縣Miaoli County', priority: 88 },
  { text: '臺中市Taichung City', value: '臺中市Taichung City', priority: 87 },
  { text: '彰化市Changhua City', value: '彰化市Changhua City', priority: 86 },
  { text: '彰化縣Changhua County', value: '彰化縣Changhua County', priority: 85 },
  { text: '南投市Nantou City', value: '南投市Nantou City', priority: 84 },
  { text: '南投縣Nantou County', value: '南投縣Nantou County', priority: 83 },
  // 南部 Southern Taiwan (priority: 79-70)
  { text: '雲林縣Yunlin County', value: '雲林縣Yunlin County', priority: 79 },
  { text: '嘉義市Chiayi City', value: '嘉義市Chiayi City', priority: 78 },
  { text: '嘉義縣Chiayi County', value: '嘉義縣Chiayi County', priority: 77 },
  { text: '臺南市Tainan City', value: '臺南市Tainan City', priority: 76 },
  { text: '高雄市Kaohsiung City', value: '高雄市Kaohsiung City', priority: 75 },
  { text: '屏東市Pingtung City', value: '屏東市Pingtung City', priority: 74 },
  { text: '屏東縣Pingtung County', value: '屏東縣Pingtung County', priority: 73 },
  // 東部 Eastern Taiwan (priority: 69-60)
  { text: '宜蘭市Yilan City', value: '宜蘭市Yilan City', priority: 69 },
  { text: '宜蘭縣Yilan County', value: '宜蘭縣Yilan County', priority: 68 },
  { text: '花蓮市Hualien  City', value: '花蓮市Hualien  City', priority: 67 },
  { text: '花蓮縣Hualien County', value: '花蓮縣Hualien County', priority: 66 },
  { text: '臺東市Taitung City', value: '臺東市Taitung City', priority: 65 },
  { text: '臺東縣Taitung County', value: '臺東縣Taitung County', priority: 64 },
  // 離島 Outlying Islands (priority: 59-50)
  { text: '澎湖縣Penghu County', value: '澎湖縣Penghu County', priority: 59 },
  { text: '金門縣Kinmen County', value: '金門縣Kinmen County', priority: 58 },
  { text: '連江縣Lienchiang County', value: '連江縣Lienchiang County', priority: 57 },
  { text: '馬祖Matsu', value: '馬祖Matsu', priority: 56 },
  { text: '綠島Green Island', value: '綠島Green Island', priority: 55 },
  { text: '蘭嶼Orchid Island', value: '蘭嶼Orchid Island', priority: 54 },
];

// Education degree options
export const degreesArray = [
  { name: '博士Doctor', code: 'doctor' },
  { name: '碩士Master', code: 'master' },
  { name: '學士University', code: 'bachelor' },
];

// Education status options
export const statusArray = [
  '畢業Graduated',
  '肄業Incomplete',
  '在學中Undergraduate'
];

// Activity options for 2026 campus recruitment
// Each activity includes startTime/endTime in ISO 8601 format (Taiwan timezone UTC+8)
// Activities without confirmed time (startTime: null) are only shown during non-event periods
export const activityOptions = [
  {
    value: 'ntu2026',
    label: '台灣大學博覽會 National Taiwan University Expo',
    startTime: '2026-03-07T09:30:00+08:00',
    endTime: '2026-03-07T16:30:00+08:00',
  },
  {
    value: 'cycu2026',
    label: '中原大學博覽會 Chung Yuan Christian University Expo',
    startTime: '2026-03-11T10:00:00+08:00',
    endTime: '2026-03-11T15:30:00+08:00',
  },
  {
    value: 'ntut2026',
    label: '台北科技大學說明會 National Taipei University of Technology Information Session',
    startTime: '2026-03-12T13:30:00+08:00',
    endTime: '2026-03-12T14:20:00+08:00',
  },
  {
    value: 'ntust2026',
    label: '台灣科技大學說明會 National Taiwan University of Science and Technology Information Session',
    startTime: '2026-03-13T14:20:00+08:00',
    endTime: '2026-03-13T15:10:00+08:00',
  },
  {
    value: 'nycu2026',
    label: '國立陽明交通大學博覽會 National Yang Ming Chiao Tung University Expo',
    startTime: '2026-03-14T10:00:00+08:00',
    endTime: '2026-03-14T16:00:00+08:00',
  },
  {
    value: 'ncku2026',
    label: '成功大學說明會 National Cheng Kung University Information Session',
    startTime: '2026-03-14T20:00:00+08:00',
    endTime: '2026-03-14T20:50:00+08:00',
  },
  {
    value: 'ncku20261',
    label: '成功大學博覽會 National Cheng Kung University Expo',
    startTime: '2026-03-15T10:00:00+08:00',
    endTime: '2026-03-15T15:00:00+08:00',
  },
  {
    value: 'ntut20261',
    label: '台北科技大學博覽會 National Taipei University of Technology Expo',
    startTime: '2026-03-19T11:00:00+08:00',
    endTime: '2026-03-19T16:00:00+08:00',
  },
  {
    value: 'ncu2026',
    label: '中央大學博覽會 National Central University Expo',
    startTime: '2026-03-22T09:30:00+08:00',
    endTime: '2026-03-22T15:30:00+08:00',
  },
  {
    value: 'niu2026',
    label: '宜蘭大學博覽會 National Ilan University Expo',
    startTime: '2026-03-25T10:00:00+08:00',
    endTime: '2026-03-25T15:30:00+08:00',
  },
  {
    value: 'ntust20261',
    label: '台灣科技大學博覽會 National Taiwan University of Science and Technology Expo',
    startTime: '2026-03-27T10:00:00+08:00',
    endTime: '2026-03-27T16:00:00+08:00',
  },
  {
    value: 'yzu2026',
    label: '元智大學博覽會 Yuan Ze University Expo',
    startTime: '2026-04-08T10:00:00+08:00',
    endTime: '2026-04-08T15:30:00+08:00',
  },
  {
    value: 'npust2026',
    label: '國立屏東科技大學博覽會 National Pingtung University of Science and Technology Expo',
    startTime: '2026-05-06T09:30:00+08:00',
    endTime: '2026-05-06T15:00:00+08:00',
  },
  {
    value: '2026ocsjf',
    label: '2026年僑生就業博覽會 2026 Overseas Compatriot Students Career Fair',
    startTime: null, // Time to be confirmed
    endTime: null,
  },
];
